import add from './modules/add';
import _init from './modules/init';
import addListener from './modules/addListener';
import _inList from './modules/inList';
import _isListen from './modules/isListen';
import _component from './modules/component';

class EventsLogger {
  constructor(_owner) {
    this._owner = _owner;
    this.loggersList = {};
  }

  add() {
    return add.apply(this, arguments);
  }

  _init() {
    return _init.apply(this, arguments);
  }

  addListener() {
    return addListener.apply(this, arguments);
  }

  _inList() {
    return _inList.apply(this, arguments);
  }

  _isListen() {
    return _isListen.apply(this, arguments);
  }

  _component() {
    return _component.apply(this, arguments);
  }
}

export default EventsLogger;
